<ion-header *ngIf="isMobile">
  <codere-navbar titulo=""> </codere-navbar>
</ion-header>

<ion-content [ngClass]="{'is-mobile': isMobile}">
  <img class="betbuilder--top-banner" [src]="getBanner()" (click)="navigateToGame()" />
  <div class="content">
    <p class="betbuilder--title">{{ "SPO_BetbuilderTitle" | translate }}</p>
    <h1 class="betbuilder--title-big">{{ "SPO_BetbuilderTitleBig" | translate }}</h1>
    <ion-grid>
      <ion-row class="py-3">
        <ion-col size="6" class="first-col">
          <ul class="betbuilder--steps">
            <li class="mt-3">
              <div class="betbuilder--paso-wrapper">
                <span class="betbuilder--paso"> Paso 1 - </span>
              </div>
              <span class="betbuilder--paso-description"> {{ "SPO_BetbuilderPaso1" | translate }} </span>
            </li>
            <li class="mt-3">
              <div class="betbuilder--paso-wrapper">
                <span class="betbuilder--paso"> Paso 2 - </span>
              </div>
              <span class="betbuilder--paso-description"> {{ "SPO_BetbuilderPaso2" | translate }} </span>
            </li>
            <li class="mt-3">
              <div class="betbuilder--paso-wrapper">
                <span class="betbuilder--paso"> Paso 3 - </span>
              </div>
              <span class="betbuilder--paso-description"> {{ "SPO_BetbuilderPaso3" | translate }} </span>
            </li>
            <li class="mt-3">
              <div class="betbuilder--paso-wrapper">
                <span class="betbuilder--paso"> Paso 4 - </span>
              </div>
              <span class="betbuilder--paso-description"> {{ "SPO_BetbuilderPaso4" | translate }} </span>
            </li>
            <li class="mt-3">
              <div class="betbuilder--paso-wrapper">
                <span class="betbuilder--paso"> Paso 5 - </span>
              </div>
              <span class="betbuilder--paso-description"> {{ "SPO_BetbuilderPaso5" | translate }} </span>
            </li>
            <li class="mt-3">
              <div class="betbuilder--paso-wrapper">
                <span class="betbuilder--paso"> Paso 6 - </span>
              </div>
              <span class="betbuilder--paso-description"> {{ "SPO_BetbuilderPaso6" | translate }} </span>
            </li>
          </ul>
        </ion-col>
        <ion-col size="6" class="last-col">
          <video width="100%" height="100%" playsInline autoplay controls [muted]="true">
            <source [src]="videoUrl" type="video/mp4" />
          </video>
        </ion-col>
      </ion-row>
    </ion-grid>

    <ion-row class="button-row">
      <div class="center-button">
        <ion-button class="betbuilder--button" (click)="navigateToGame()">
          <ion-label>Crea Tu Apuesta Ahora</ion-label>
        </ion-button>
      </div>
    </ion-row>

    <ion-grid>
      <ion-row class="cards--wrapper">
        <ion-col size="12" class="card--wrapper">
          <img src="assets/global/img/betbuilder/1.svg" alt="" class="card--image" />
          <div class="card--body">{{ "SPO_BetbuilderCard1" | translate }}</div>
        </ion-col>
        <ion-col size="12" class="card--wrapper">
          <img src="assets/global/img/betbuilder/2.svg" alt="" class="card--image" />
          <div class="card--body">{{ "SPO_BetbuilderCard2" | translate }}</div>
        </ion-col>
        <ion-col size="12" class="card--wrapper">
          <img src="assets/global/img/betbuilder/3.svg" alt="" class="card--image" />
          <div class="card--body">{{ "SPO_BetbuilderCard3" | translate }}</div>
        </ion-col>
        <ion-col size="12" class="card--wrapper">
          <img src="assets/global/img/betbuilder/4.svg" alt="" class="card--image" />
          <div class="card--body">{{ "SPO_BetbuilderCard4" | translate }}</div>
        </ion-col>
        <ion-col size="12" class="card--wrapper">
          <img src="assets/global/img/betbuilder/5.svg" alt="" class="card--image" />
          <div class="card--body">{{ "SPO_BetbuilderCard5" | translate }}</div>
        </ion-col>
      </ion-row>
    </ion-grid>
  </div>
</ion-content>
